import {
  IconComfortArmchair16,
  IconComfortCleaning16,
  IconComfortFridge16,
  IconComfortFruit16,
  IconComfortLocker16,
  IconComfortReception16,
  IconComfortRenovation16,
  IconComfortTea16,
  IconComfortWiFi16,
  IconCommunicationComment16,
  IconCommunicationPhone16,
  IconCommunicationSupport16,
  IconFileDocument16,
  IconFilePrint16,
  IconFunctionalCalendar16,
  IconInfrastructureBike16,
  IconInfrastructureFitness16,
  IconInfrastructureInternet16,
  IconInfrastructureOffice16,
  IconInfrastructureParking16,
  IconInfrastructureRestaurant16,
  IconMapPin16,
  IconMediaFlipchart16,
  IconSafetySecurity16,
} from '@cian/ui-kit-design-tokens/icons';

export const amenitiesIcons = {
  bike_parking: <IconInfrastructureBike16 />,
  cafe: <IconInfrastructureRestaurant16 />,
  cleaning: <IconComfortCleaning16 />,
  events: <IconFunctionalCalendar16 />,
  fax: <IconFileDocument16 />,
  flipchart: <IconMediaFlipchart16 />,
  fruits: <IconComfortFruit16 />,
  furniture: <IconInfrastructureOffice16 />,
  gym: <IconInfrastructureFitness16 />,
  internet: <IconInfrastructureInternet16 />,
  kitchen: <IconComfortFridge16 />,
  legal_address: <IconMapPin16 />,
  lockers: <IconComfortLocker16 />,
  meeting_room: <IconCommunicationComment16 />,
  modern: <IconComfortRenovation16 />,
  parking: <IconInfrastructureParking16 />,
  phone_booth: <IconCommunicationPhone16 />,
  printer: <IconFilePrint16 />,
  reception: <IconComfortReception16 />,
  rest_zone: <IconComfortArmchair16 />,
  security: <IconSafetySecurity16 />,
  tea: <IconComfortTea16 />,
  tech_support: <IconCommunicationSupport16 />,
  wifi: <IconComfortWiFi16 />,
};
